import {
  ACTIONS,
  GenomicsAdminTypes,
} from "../interfaces/actionTypes/GenomicsAdminType";

type InitialState = {
  allPackageList: Array<any>;
  usersRights: Array<any>;
  packageByName: Array<any>;
  bankName: Array<any>;
  pin_code: Array<any>;
  cities: Array<any>;
  areaList: Array<any>;
  agentsList: Array<any>;
  phleboList: Array<any>;
  packageList: Array<any>;
  partnerList: Array<any>;
  couponList: Array<any>;
  campCouponList: Array<any>;
  recharge: Array<any>;
  createBooking: Object;
  uploadRatelistData: Object;
  booking: Object;
  createIMGBooking: object;
  centreCode: Object;
  createQrCode: Object;
  labOrgCode: Object;
  todays_positive_calls: Object;
  lead_details: Object;
  leadById: Object;
  leads: Array<any>;
  bookingList: Array<any>;
  tatTests: Array<any>;
  tatTestsNames: Array<any>;
  comment: any;
  data: any;
  users: any;
  bookingsComment: any;
  lead_id: number;
  read_call_details: object;
  all_recordings: object;
  whatsappComments: object;
  whatsappCommentsByLead: object;
  callStats: object;
  complaint: object;
  complaints: object;
  lead_source: any;
  booking_slots: object;
  search_results: object;
  call_status: object;
  all_lead: object;
  call_transfer: object;
  user_panel: object;
  agentBYUserGroup: object;
  centreCreationMasterAdvancePayment: Array<any>;
  post_advance_payment: Array<any>;
  centerInfo: Array<any>;
  centreUsersData: Array<any>;
  centers: Array<any>;
  centreLabOrg: Array<any>;
  userDetails: Array<any>;
  loading: boolean;
  advancePaymentList: Array<any>;
  clientLedgerDetails: Array<any>;
  clientLedgerBalance: Array<any>;
  labDetails: Array<any>;
  checkGeoFenceStatus: boolean;
  geoFencesMapMyIndia: Array<any>;
  mapmyindiaAccessToken: Array<any>;
  timeslots: Array<any>;
  salesManager: Array<any>;
  salesExecutive: Array<any>;
  identityProofData: Array<any>;
  stateList: Array<any>;
  paymentModeList: Array<any>;
  testCategory: Array<any>;
  sameNumberBooking: boolean;
  redCoin: Array<any>;
  tagProccessingLab: Array<any>;
  centreProcessingRate: Array<any>;
  centreInvoice: Array<any>;
  labCredential: Array<any>;
  rateList: Array<any>;
  rateListExport: Array<any>;
  rateListFilter: Array<any>;
  rateListPackage: Array<any>;
  reportStatus: Array<any>;
  bookingStatus: Array<any>;
  exportCCLedgerData: Array<any>;
  salesSummary: Array<any>;
  centreCampPackage: Array<any>;
  campPackages: Array<any>;
  bookingStatusCount: object;
  reportDownload: Object;
  subCenter: Array<any>;
  imagingTimeSlots: Array<any>;
  multiplePackage: Array<any>;
  displayCities: Array<any>;
  doctorInfo: Array<any>;
  employee: Array<any>;
  paymentSendLink: Array<any>;
  paymentReSendLink: Array<any>;
  reportDownloadWithout: Object;
  refDoctor: Array<any>;
  doctorQual: Array<any>;
  doctorSpec: Array<any>;
  responseRefDoctor: Object;
  tubeByBooking: Array<any>;
  receivedPackages: Array<any>;
  updatebBookingData: Array<any>;
  centerPackages: Array<any>;
  zoneList: Object;
  bookingsByCentre: Array<any>;
  updateRefDoc:Array<any>;

};

const initialState: InitialState = {
  exportCCLedgerData: [],
  updatebBookingData: [],
  tubeByBooking: [],
  receivedPackages: [],
  bookingsByCentre: [],
  salesSummary: [],
  centreCampPackage: [],
  campPackages: [],
  allPackageList: [],
  usersRights: [],
  packageByName: [],
  bankName: [],
  pin_code: [],
  salesManager: [],
  salesExecutive: [],
  createIMGBooking: {},
  cities: [],
  areaList: [],
  agentsList: [],
  phleboList: [],
  packageList: [],
  partnerList: [],
  labDetails: [],
  couponList: [],
  recharge: [],
  paymentModeList: [],
  identityProofData: [],
  stateList: [],
  createBooking: {},
  uploadRatelistData: {},
  booking: {},
  centreCode: {},
  createQrCode: {},
  labOrgCode: {},
  lead_details: {},
  leadById: {},
  todays_positive_calls: {},
  leads: [],
  bookingList: [],
  campCouponList: [],
  tatTests: [],
  tatTestsNames: [],
  comment: {},
  data: {},
  users: {},
  loading: false,
  read_call_details: {},
  all_recordings: {},
  whatsappComments: {},
  whatsappCommentsByLead: {},
  callStats: {},
  complaint: {},
  complaints: {},
  bookingsComment: {},
  lead_id: 0,
  lead_source: {},
  booking_slots: {},
  search_results: {},
  sameNumberBooking: false,
  call_status: {},
  all_lead: {},
  call_transfer: {},
  agentBYUserGroup: {},
  centreCreationMasterAdvancePayment: [],
  post_advance_payment: [],
  centerInfo: [],
  centreUsersData: [],
  centers: [],
  centreLabOrg: [],
  userDetails: [],
  user_panel: {},
  advancePaymentList: [],
  clientLedgerDetails: [],
  clientLedgerBalance: [],
  checkGeoFenceStatus: false,
  geoFencesMapMyIndia: [],
  mapmyindiaAccessToken: [],
  testCategory: [],
  timeslots: [],
  redCoin: [],
  tagProccessingLab: [],
  centreProcessingRate: [],
  centreInvoice: [],
  labCredential: [],
  rateList: [],
  rateListExport: [],
  rateListFilter: [],
  rateListPackage: [],
  reportStatus: [],
  bookingStatus: [],
  bookingStatusCount: {},
  reportDownload: {},
  reportDownloadWithout: {},
  subCenter: [],
  imagingTimeSlots: [],
  multiplePackage: [],
  displayCities: [],
  doctorInfo: [],
  employee: [],
  paymentSendLink: [],
  paymentReSendLink: [],
  refDoctor: [],
  doctorQual: [],
  doctorSpec: [],
  responseRefDoctor: {},
  centerPackages: [],
  zoneList: {},
  updateRefDoc:[],};

const GenomicsAdminReducer = (
  state = initialState,
  action: GenomicsAdminTypes
) => {
  switch (action.type) {
    case ACTIONS.GET_USERS_RIGHTS:
      return {
        ...state,
        usersRights: action.payload,
        loading: false,
      };
      case ACTIONS.UPDATE_BOOKING:
            return {
                ...state,
                updatebBookingData: action.payload,
                loading: false,
            };
    case ACTIONS.GET_ZONE:
      return {
        ...state,
        zoneList: action.payload,
        loading: false,
      };
      case ACTIONS.GET_BOOKINGS_BY_CENTRE:
        return {
            ...state,
            bookingsByCentre: action.payload,
            loading: false,
        };
        case ACTIONS.UPDATE_REF_UPDATE:
          return {
              ...state,
              updateRefDoc: action.payload,
              loading: false,
          };
    case ACTIONS.GET_RECEIVED_PACKAGES:
      return {
        ...state,
        receivedPackages: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PACKAGES_BY_CENTER:
      return {
        ...state,
        centerPackages: action.payload,
        loading: false,
      };
    case ACTIONS.BOOKING_DATA_RESET:
      return {
        ...state,
        createIMGBooking: {},
        receivedPackages: {},
        tubeByBooking: {},
        updatebBookingData: {},
        doctorSpec:{},
        doctorQual:{},

      };
    case ACTIONS.GET_TUBE_BY_BOOKING:
      return {
        ...state,
        tubeByBooking: action.payload,
        loading: false,
      };
    case ACTIONS.POST_REF_DOCTOR:
      return {
        ...state,
        responseRefDoctor: action.payload,
        loading: false,
      };
    case ACTIONS.REF_DOCTOR_RESET:
      return {
        ...state,
        responseRefDoctor: {},
      };
    case ACTIONS.GET_DOCTOR_SPEC:
      return {
        ...state,
        doctorSpec: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SALES_SUMMARY:
      return {
        ...state,
        salesSummary: action.payload,
        loading: false,
      };
    case ACTIONS.GET_DOCTOR_QUAL:
      return {
        ...state,
        doctorQual: action.payload,
        loading: false,
      };
    case ACTIONS.GET_REF_DOCTOR:
      return {
        ...state,
        refDoctor: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PAYMENT_SEND_LINK:
      return {
        ...state,
        paymentSendLink: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PAYMENT_RESEND_LINK:
      return {
        ...state,
        paymentReSendLink: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_CAMP_PACKAGE:
      return {
        ...state,
        centreCampPackage: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CAMP_PACKAGES:
      return {
        ...state,
        campPackages: action.payload,
        loading: false,
      };
    case ACTIONS.GET_REPORT_DOWNLOAD:
      return {
        ...state,
        reportDownload: action.payload,
        loading: false,
      };
    case ACTIONS.EXPORT_CCLEDGER:
      return {
        ...state,
        exportCCLedgerData: action.payload,
        loading: false,
      };
    case ACTIONS.UPLOAD_RATELIST:
      return {
        ...state,
        uploadRatelistData: action.payload,
        loading: false,
      };
    case ACTIONS.GET_REPORT_DOWNLOAD_WITHOUT:
      return {
        ...state,
        reportDownloadWithout: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_STATUS_COUNT:
      return {
        ...state,
        bookingStatusCount: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_STATUS:
      return {
        ...state,
        bookingStatus: action.payload,
        loading: false,
      };
    case ACTIONS.GET_REPORT_STATUS:
      return {
        ...state,
        reportStatus: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PIN_CODE:
      return {
        ...state,
        pin_code: action.payload,
        loading: false,
      };

    case ACTIONS.UPLOAD_FILE:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PHLEBOS:
      return {
        ...state,
        phleboList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CITIES:
      return {
        ...state,
        cities: action.payload,
        loading: false,
      };
    case ACTIONS.GET_AREA:
      return {
        ...state,
        areaList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_POSTIVE_CALLS_COMMENTS:
      return {
        ...state,
        todays_positive_calls: action.payload,
        loading: false,
      };
    case ACTIONS.GET_STATE_LIST:
      return {
        ...state,
        stateList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SALES_MANAGER:
      return {
        ...state,
        salesManager: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SALES_EXECUTIVE:
      return {
        ...state,
        salesExecutive: action.payload,
        loading: false,
      };
    case ACTIONS.SET_COMMENTS:
      return {
        ...state,
        comment: action.payload,
        loading: false,
      };
    case ACTIONS.ADD_POSTIVE_CALLS_COMMENT:
      return {
        ...state,
        todays_positive_calls: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LEAD_DETAILS:
      return {
        ...state,
        lead_details: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LEADS:
      return {
        ...state,
        leads: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LEAD_BY_ID:
      return {
        ...state,
        leadById: action.payload,
        loading: false,
      };
    case ACTIONS.LEAD_DETAILS_RESET:
      return {
        ...state,
        leadById: {},
        lead_details: {},
        loading: false,
      };
    case ACTIONS.GET_AGENTS:
      return {
        ...state,
        agentsList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_AGENTS_BY_USERGROUP:
      return {
        ...state,
        agentBYUserGroup: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PACKAGES:
      return {
        ...state,
        packageList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PARTNERS:
      return {
        ...state,
        partnerList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_COUPONS:
      return {
        ...state,
        couponList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CAMPCOUPONS:
      return {
        ...state,
        campCouponList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RECHARGE:
      return {
        ...state,
        recharge: action.payload,
        loading: false,
      };
    case ACTIONS.CREATE_BOOKING:
      return {
        ...state,
        createBooking: action.payload,
        loading: false,
      };
    case ACTIONS.CREATE_NEW_CENTER:
      return {
        ...state,
        createCenter: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_LIST:
      return {
        ...state,
        bookingList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TAT_TESTS:
      return {
        ...state,
        tatTests: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TAT_TESTS_NAMES:
      return {
        ...state,
        tatTestsNames: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_BY_ID:
      return {
        ...state,
        booking: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_CODE:
      return {
        ...state,
        centreCode: action.payload,
        loading: false,
      };
    case ACTIONS.CREATE_QR_PAYMENT:
      return {
        ...state,
        createQrCode: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LAB_ORG_CODE:
      return {
        ...state,
        labOrgCode: action.payload,
        loading: false,
      };
    case ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTIONS.CREATE_CALL:
      return {
        ...state,
        loading: false,
        lead_id: action.payload,
      };
    case ACTIONS.GET_RECORDINGS:
      return {
        ...state,
        all_recordings: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LEAD_SOURCE:
      return {
        ...state,
        lead_source: action.payload,
        loading: false,
      };
    case ACTIONS.SEARCH_CALL:
      return {
        ...state,
        search_results: action.payload,
        loading: false,
      };
    case ACTIONS.ADD_COMMENT:
      return {
        ...state,
        comments: action.payload,
        loading: false,
      };
    case ACTIONS.BOOKING_RESET:
      return {
        ...state,
        createBooking: {},
        bookingList: [],
        loading: false,
      };
    case ACTIONS.GET_BOOKINGS_COMMENTS:
      return {
        ...state,
        bookingsComment: action.payload,
        loading: false,
      };
    case ACTIONS.ADD_BOOKINGS_COMMENT:
      return {
        ...state,
        bookingsComment: action.payload,
        loading: false,
      };
    case ACTIONS.GET_WHATSAPP_COMMENTS:
      return {
        ...state,
        whatsappComments: action.payload,
        loading: false,
      };
    case ACTIONS.GET_WHATSAPP_COMMENTS_BY_LEAD:
      return {
        ...state,
        whatsappCommentsByLead: action.payload,
        loading: false,
      };
    case ACTIONS.SEND_WHATSAPP_COMMENTS:
      return {
        ...state,
        whatsappComments: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CALL_STATS:
      return {
        ...state,
        callStats: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LAB_DETAILS:
      return {
        ...state,
        labDetails: action.payload,
        loading: false,
      };
    case ACTIONS.RAISE_COMPLAINT:
      return {
        ...state,
        complaint: action.payload,
        loading: false,
      };
    case ACTIONS.GET_COMPLAINTS:
      return {
        ...state,
        complaints: action.payload,
        loading: false,
      };
    case ACTIONS.ASSIGN_DOCTOR:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case ACTIONS.SEND_FEEDBACK:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case ACTIONS.GET_AVAILABLE_SLOTS:
      return {
        ...state,
        booking_slots: action.payload,
        loading: false,
      };
    case ACTIONS.GET_ALL_LEADS:
      return {
        ...state,
        all_lead: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PANEL_USERS:
      return {
        ...state,
        user_panel: action.payload,
        loading: false,
      };
    case ACTIONS.LEAD_TRANSFER_BY_COMMA:
      return {
        ...state,
        all_lead: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_CREATION_MASTER_ADVANCE_PAYMENT:
      return {
        ...state,
        centreCreationMasterAdvancePayment: action.payload,
        loading: false,
      };
    case ACTIONS.POST_ADVANCE_PAYMENT:
      return {
        ...state,
        post_advance_payment: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTER_INFORMATION:
      return {
        ...state,
        centerInfo: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_USERS:
      return {
        ...state,
        centreUsersData: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTERS:
      return {
        ...state,
        centers: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_LAB_ORG:
      return {
        ...state,
        centreLabOrg: action.payload,
        loading: false,
      };
    case ACTIONS.GET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
        loading: false,
      };
    case ACTIONS.GET_ADVANCE_PAYMENT:
      return {
        ...state,
        advancePaymentList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CLIENT_LEDGER_DETAILS:
      return {
        ...state,
        clientLedgerDetails: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CLIENT_LEDGER_BALANCE:
      return {
        ...state,
        clientLedgerBalance: action.payload,
        loading: false,
      };
    case ACTIONS.CHECK_GEOFENCE_AREA:
      return {
        ...state,
        checkGeoFenceStatus: action.payload,
        loading: false,
      };
    case ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA:
      return {
        ...state,
        geoFencesMapMyIndia: action.payload,
        loading: false,
      };
    case ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN:
      return {
        ...state,
        mapmyindiaAccessToken: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TIMESLOTS:
      return {
        ...state,
        timeslots: action.payload,
        loading: false,
      };
    case ACTIONS.SAME_NUMBER_BOOKING:
      return {
        ...state,
        sameNumberBooking: action.payload,
        loading: false,
      };
    case ACTIONS.GET_IENTITY_PROOF_DATA:
      return {
        ...state,
        identityProofData: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PAYMENT_MODE_LIST:
      return {
        ...state,
        paymentModeList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TEST_CATEGORY:
      return {
        ...state,
        testCategory: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RED_COIN:
      return {
        ...state,
        redCoin: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TAG_PROCCESSING_LAB:
      return {
        ...state,
        tagProccessingLab: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_PROCESSING_RATE:
      return {
        ...state,
        centreProcessingRate: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CENTRE_INVOICE:
      return {
        ...state,
        centreInvoice: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LAB_CREDENTIAL:
      return {
        ...state,
        labCredential: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RATELIST:
      return {
        ...state,
        rateList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RATELIST_EXPORT:
      return {
        ...state,
        rateListExport: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RATELIST_FILTER:
      return {
        ...state,
        rateListFilter: action.payload,
        loading: false,
      };
    case ACTIONS.GET_RATELIST_PACKAGE:
      return {
        ...state,
        rateListPackage: action.payload,
        loading: false,
      };
    case ACTIONS.GET_ALL_PACKAGES:
      return {
        ...state,
        allPackageList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PACKAGE_BY_NAME:
      return {
        ...state,
        packageByName: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BANK_NAME:
      return {
        ...state,
        bankName: action.payload,
        loading: false,
      };
    case ACTIONS.GET_EMPLOYEE:
      return {
        ...state,
        employee: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SUB_CENTER_INFORMATION:
      return {
        ...state,
        subCenter: action.payload,
        loading: false,
      };
    case ACTIONS.GET_IMAGING_TIMESLOTS:
      return {
        ...state,
        imagingTimeSlots: action.payload,
        loading: false,
      };
    case ACTIONS.GET_MULTIPLE_PACKAGES:
      return {
        ...state,
        multiplePackage: action.payload,
        loading: false,
      };
    case ACTIONS.GET_DISPLAY_CITIES:
      return {
        ...state,
        displayCities: action.payload,
        loading: false,
      };
    case ACTIONS.GET_DOCTOR_INFO_BY_ID:
      return {
        ...state,
        doctorInfo: action.payload,
        loading: false,
      };
    case ACTIONS.CREATE_IMAGING_BOOKING:
      return {
        ...state,
        createIMGBooking: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default GenomicsAdminReducer;
